"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamedPoint = void 0;
const GeoModelCommon_1 = require("./GeoModelCommon");
const debug = !process.env.AWS_SESSION_TOKEN && false;
const typeName = 'NamedPoint';
class NamedPoint extends GeoModelCommon_1.GeoModelCommon {
    constructor({ name, ...ob }) {
        super({ ...ob });
    }
    get name() {
        return [
            this.property ?? 'UnknownProperty',
            this.locale ?? 'UnknownLocale',
            this.subLocale ?? 'UnknownSubLocale',
            this.placementPosition ?? 'UnknownPlacementPoistion',
            this.dsk ?? this.id,
        ].join(':');
    }
    set name(name) {
        const parts = name.split(':');
        const keys = ['property', 'locale', 'subLocale', 'placementPosition', 'id'];
        if (parts.length > 1) {
            parts.forEach((part, i) => {
                if (keys[i]) {
                    this[keys[i]] = part;
                }
            });
        }
    }
    get location_calculated_lat() {
        return this.locationCalculated?.lat ?? 0;
    }
    set location_calculated_lat(val) {
        if (!this.locationCalculated)
            Object.assign(this, { locationCalculated: {} });
        if (this.locationCalculated)
            this.locationCalculated.lat = val;
    }
    get location_calculated_lng() {
        return this.locationCalculated?.lng ?? 0;
    }
    set location_calculated_lng(val) {
        if (!this.locationCalculated)
            Object.assign(this, { locationCalculated: {} });
        if (this.locationCalculated)
            this.locationCalculated.lng = val;
    }
    get display_on_map() {
        return this.mapDisplayProps?.displayOnMap;
    }
    set display_on_map(yn) {
        if (!this.mapDisplayProps)
            Object.assign(this, { mapDisplayProps: {} });
        if (this.mapDisplayProps?.displayOnMap)
            this.mapDisplayProps.displayOnMap = yn ?? false;
    }
    get style() {
        return this.mapDisplayProps?.style ? JSON.stringify(this.mapDisplayProps.style, null, 1) : undefined;
    }
    set style(styleJson) {
        if (styleJson) {
            let parsedStyle;
            try {
                parsedStyle = JSON.parse(styleJson);
            }
            catch (e) {
                console.log('Error parsing', styleJson);
            }
            if (!this.mapDisplayProps)
                Object.assign(this, { mapDisplayProps: {} });
            if (this.mapDisplayProps && parsedStyle)
                this.mapDisplayProps.style = parsedStyle;
        }
    }
    get display_attributes() {
        return this.mapDisplayProps?.displayAttributes ? JSON.stringify(this.mapDisplayProps.displayAttributes, null, 1) : undefined;
    }
    set display_attributes(attJson) {
        if (attJson) {
            let parseAtts;
            try {
                parseAtts = JSON.parse(attJson);
            }
            catch (e) {
                console.log('Error parsing', attJson);
            }
            if (!this.mapDisplayProps)
                Object.assign(this, { mapDisplayProps: {} });
            if (this.mapDisplayProps && parseAtts)
                this.mapDisplayProps.displayAttributes = parseAtts;
        }
    }
    getUserAttributes() {
        const { type, name, location_lat, location_lng, ...others } = super.getUserAttributes();
        return {
            type,
            name,
            location_lat,
            location_lng,
            property: {
                type: 'String',
            },
            locale: {
                type: 'String',
            },
            subLocale: {
                type: 'String',
            },
            placementPosition: {
                type: 'String',
                label: 'Place',
            },
            location_calculated_lat: {
                type: 'Number',
                precision: 5,
                label: 'Lat_c',
            },
            location_calculated_lng: {
                type: 'Number',
                precision: 5,
                label: 'Lng_c',
            },
            display_on_map: {
                type: 'Boolean',
                label: 'Disp?',
            },
            style: {
                type: 'String',
            },
            display_attributes: {
                type: 'String',
                label: 'Atts',
            },
        };
    }
}
exports.NamedPoint = NamedPoint;
